import { render, staticRenderFns } from "./GroupMenu.vue?vue&type=template&id=3e07f7ff&scoped=true"
import script from "./GroupMenu.vue?vue&type=script&lang=js"
export * from "./GroupMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e07f7ff",
  null
  
)

export default component.exports